/**
 * Product brand — Cotidía (pensión alimenticia tracker for Chile).
 * Domain: cotidia.cl
 */
export const brand = {
  name: 'Cotidía',
  domain: 'cotidia.cl',
  url: 'https://cotidia.cl',
  tagline: 'Tu pensión alimenticia, al día.',
  taglineLong: 'Tu pensión alimenticia, al día. Con los números a la vista.',
  description:
    'Seguimiento de pensión alimenticia en Chile: monto según UTM o IMM, historial y recordatorios, sin planillas.',
  ogDescription:
    'Monto estimado según tu resolución (UTM o IMM), historial claro y avisos a tiempo. Para pagar tranquilo.',
  disclaimer:
    'Cotidía es una herramienta de seguimiento. No sustituye la resolución judicial ni constituye asesoría legal.',
  themeColor: '#3ECF8E',
  /** Marca comercial del operador (aún no es persona jurídica). */
  legalOperatorBrand: 'Dobleos',
  legalContactEmail: 'info@cotidia.cl',
  legalCity: 'Chile',
  legalUpdatedAt: '21 de agosto de 2026',
}

export const brandTitle = `${brand.name} — ${brand.tagline}`

export default brand
